/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_SwedishInputs */

const en_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swedish`)
};

const fr_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suedois`)
};

const de_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwedisch`)
};

const it_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`svedese`)
};

const ru_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`шведский`)
};

const es_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sueco`)
};

const zh_cn2_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瑞典`)
};

const ja_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スウェーデン語`)
};

const hi_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीडिश`)
};

const pt_pt2_speechmatics_target_language_swedish = /** @type {(inputs: Speechmatics_Target_Language_SwedishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sueco`)
};

/**
* | output |
* | --- |
* | "Swedish" |
*
* @param {Speechmatics_Target_Language_SwedishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_swedish = /** @type {((inputs?: Speechmatics_Target_Language_SwedishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_SwedishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_swedish(inputs)
	if (locale === "de") return de_speechmatics_target_language_swedish(inputs)
	if (locale === "it") return it_speechmatics_target_language_swedish(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_swedish(inputs)
	if (locale === "es") return es_speechmatics_target_language_swedish(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_swedish(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_swedish(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_swedish(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_swedish(inputs)
	return en_speechmatics_target_language_swedish(inputs)
});